"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _BasicToast = _interopRequireDefault(require("../BasicToast"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function createToastMiddleware() {
  return function () {
    return function () {
      return function (_ref) {
        var notification = _ref.notification;
        return _react.default.createElement(_BasicToast.default, {
          notification: notification
        });
      };
    };
  };
}

var _default = createToastMiddleware;
exports.default = _default;